export const messages = {
  en: {
    couponRule: {
      page: {
        title: 'Coupon Rules',
        subtitle: 'Manage coupon grant rules, quota configuration and fee settings'
      },
      title: 'Coupon Rules',
      ruleName: 'Rule Name',
      ruleNamePlaceholder: 'Please enter rule name',
      ruleNameRequired: 'Rule name is required',
      ruleNameMaxLength: 'Rule name cannot exceed 64 characters',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      remarkMaxLength: 'Remark cannot exceed 512 characters',
      ruleIdRequired: 'Rule ID is required',
      addRule: 'Add Rule',
      editRule: 'Edit Rule',
      deleteConfirm: 'Delete Confirmation',
      deleteRulePrompt: 'Are you sure to delete this coupon rule?',
      selectRuleFirst: 'Please select a rule first',
      coupon: 'Coupon',
      fee: 'Fee'
    },
    couponRuleCpps: {
      id: 'ID',
      coupon: 'Coupon',
      couponPlaceholder: 'Please select coupon',
      couponRequired: 'Coupon is required',
      quantity: 'Quantity',
      quantityPlaceholder: 'Please enter quantity',
      quantityRequired: 'Quantity is required',
      quantityPattern: 'Quantity must be a positive integer',
      frequency: 'Frequency',
      frequencyPlaceholder: 'Please select frequency',
      frequencyRequired: 'Frequency is required',
      once: 'Once',
      monthly: 'Monthly',
      addCoupon: 'Add Coupon',
      editCoupon: 'Edit Coupon',
      deleteConfirm: 'Delete Confirmation',
      deletePrompt: 'Are you sure to delete this coupon?',
      idRequired: 'ID is required'
    },
    couponRuleFee: {
      id: 'ID',
      fee: 'Fee',
      feePlaceholder: 'Please select fee',
      feeRequired: 'Fee is required',
      payTime: 'Payment Time',
      payMonth: 'Payment Month',
      payMonthPlaceholder: 'Please enter payment month',
      payMonthRequired: 'Payment month is required',
      payStartTime: 'Start Time',
      payStartTimePlaceholder: 'Please select start time',
      payStartTimeRequired: 'Start time is required',
      payEndTime: 'End Time',
      payEndTimePlaceholder: 'Please select end time',
      payEndTimeRequired: 'End time is required',
      addFee: 'Add Fee',
      deleteConfirm: 'Delete Confirmation',
      deletePrompt: 'Are you sure to delete this fee rule?'
    },
  },
  zh: {
    couponRule: {
      page: {
        title: '优惠券规则',
        subtitle: '管理优惠券赠送规则、额度配置与缴费设置'
      },
      title: '优惠券规则',
      ruleName: '规则名称',
      ruleNamePlaceholder: '请输入规则名称',
      ruleNameRequired: '规则名称不能为空',
      ruleNameMaxLength: '规则名称不能超过64个字符',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      remarkMaxLength: '备注不能超过512个字符',
      ruleIdRequired: '规则ID不能为空',
      addRule: '添加规则',
      editRule: '编辑规则',
      deleteConfirm: '删除确认',
      deleteRulePrompt: '确定要删除此优惠券规则吗？',
      selectRuleFirst: '请先选择规则',
      coupon: '优惠券',
      fee: '缴费赠送'
    },
    couponRuleCpps: {
      id: '编号',
      coupon: '优惠券',
      couponPlaceholder: '请选择优惠券',
      couponRequired: '优惠券不能为空',
      quantity: '数量',
      quantityPlaceholder: '请输入数量',
      quantityRequired: '数量不能为空',
      quantityPattern: '数量必须为正整数',
      frequency: '频率',
      frequencyPlaceholder: '请选择频率',
      frequencyRequired: '频率不能为空',
      once: '赠送一次',
      monthly: '每月赠送',
      addCoupon: '添加优惠券',
      editCoupon: '编辑优惠券',
      deleteConfirm: '删除确认',
      deletePrompt: '确定要删除此优惠券吗？',
      idRequired: 'ID不能为空'
    },
    couponRuleFee: {
      id: '编号',
      fee: '费用',
      feePlaceholder: '请选择费用',
      feeRequired: '费用不能为空',
      payTime: '缴费时间',
      payMonth: '缴费月',
      payMonthPlaceholder: '请输入缴费月',
      payMonthRequired: '缴费月不能为空',
      payStartTime: '开始时间',
      payStartTimePlaceholder: '请选择开始时间',
      payStartTimeRequired: '开始时间不能为空',
      payEndTime: '结束时间',
      payEndTimePlaceholder: '请选择结束时间',
      payEndTimeRequired: '结束时间不能为空',
      addFee: '添加缴费赠送',
      deleteConfirm: '删除确认',
      deletePrompt: '确定要删除此缴费规则吗？'
    },
  }
}